import { COLORS } from 'app/constants'
import BigNumber from 'bignumber.js'
import React from 'react'
import { Text } from 'styles/reactnative'
import { useIndexPrice } from '../../hooks/trade/indexprice'
import CRenderEmpty from '../CRenderEmpty'

const RealtimePnlPrice = ({
	pricelist = [],
	style = {},
	dp = undefined,
}: any) => {
	let price = 0
	let pnlprice = 0
	let sumpnlprice = 0
	const { data, mutate, getPrice } = useIndexPrice(
		pricelist?.[0]?.exchange_pairs_id || 5000
	)

	pricelist?.map((item: any) => {
		mutate(undefined, item?.exchange_pairs_id)
		const currentprice = getPrice(item?.exchange_pairs_id)

		if (item?.long_short == 'L') {
			pnlprice = BigNumber(currentprice).minus(item?.avgprice).toNumber()
		} else {
			pnlprice = BigNumber(item?.avgprice).minus(currentprice).toNumber()
		}
		sumpnlprice = BigNumber(sumpnlprice)
			.plus(BigNumber(pnlprice).multipliedBy(item?.amount))
			.toNumber()
	})

	return (
		<>
			<Text
				style={{
					justifyContent: 'flex-end',
					color:
						sumpnlprice > 0
							? COLORS.lightGreen
							: sumpnlprice === 0
							? 'black'
							: COLORS.lightRed,

					...style,
				}}>
				{sumpnlprice > 0 ? '+' : ''}
				{BigNumber(sumpnlprice)?.toFormat(0)}원
			</Text>
		</>
	)
}

export default React.memo(RealtimePnlPrice)
